import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BusinessModel, ContactModel, EBusinessType} from '../../../@models';

@Component({
  selector: 'ngx-business-edit',
  templateUrl: './business-edit.component.html',
  styleUrls: ['./business-edit.component.scss'],
})
export class BusinessEditComponent {

  public BusinessType = EBusinessType;

  @Input() item: BusinessModel;
  @Input() general: ContactModel;
  @Input() isSaving = false;
  @Input() showHeader = true;
  @Input() showFooter = true;

  @Output() save = new EventEmitter<BusinessModel>();
  @Output() cancel = new EventEmitter<BusinessModel>();

  public cantChangeName(business: BusinessModel) {
    return ['nrka','nrkg','nrvi','nrkj','nrbm','micamation','ceva.*airport.*','nrkv']
      .find(name => new RegExp(`^${name}$`, 'i').test(business.name));
  }
}